import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Space, Typography, Row, Col, notification } from 'antd';
import { PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { listDocumentTemplates, deleteDocumentTemplate } from '../../actions/documentTemplateActions';
import { DOCUMENT_TEMPLATE_DELETE_REQUEST } from '../../constants/documentTemplateConstants';
import { useTranslation } from 'react-i18next';
import ListItemsDataTable from '../../components/crud/ListItemsDataTable.component';

const { Title } = Typography;

const DocumentTemplateListScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();

  const [filter, setFilter] = useState({
    query: '',
    page: 1,
    limit: 10,
    filter: 'name'
  });

  const documentTemplateList = useSelector(state => state.documentTemplateList);
  const { loading, error, documentTemplates = [], currentPage = 1, totalPages = 1, totalCount } = documentTemplateList;

  const documentTemplateDtoState = useSelector(state => state.documentTemplateDto);
  const { documentTemplateDto } = documentTemplateDtoState;

  const documentTemplateDelete = useSelector(state => state.documentTemplateDelete);
  const { loading: loadingDelete, error: errorDelete, success: successDelete } = documentTemplateDelete;

  // Configure columns for ListItemsDataTable
  const tableDto = {
    Name: { 
      isSummaryProp: true,
      isFilterable: true,
      type: 'string'
    },
    Specialty: { 
      isSummaryProp: true,
      isFilterable: true,
      type: 'string'
    },
    Language: { 
      isSummaryProp: true,
      isFilterable: true,
      type: 'string'
    }
  };

  useEffect(() => {
    dispatch(listDocumentTemplates({ ...filter }));
    if (!documentTemplateDto) {
      dispatch({ type: 'DOCUMENT_TEMPLATE_DTO_REQUEST' });
    }
  }, [dispatch, successDelete, filter]);

  useEffect(() => {
    if (successDelete) {
      api.success({
        message: t('Success'),
        description: t('Template deleted successfully'),
        placement: 'bottomRight'
      });
      dispatch({ type: 'DOCUMENT_TEMPLATE_DELETE_RESET' });
      dispatch(listDocumentTemplates({ ...filter }));
    }
    if (errorDelete) {
      api.error({
        message: t('Error'),
        description: errorDelete,
        placement: 'bottomRight'
      });
      dispatch({ type: 'DOCUMENT_TEMPLATE_DELETE_RESET' });
    }
  }, [successDelete, errorDelete, api, dispatch, t, filter]);

  const handleDelete = (id) => {
    dispatch(deleteDocumentTemplate(id));
  };

  const handleEdit = (id) => {
    navigate(`/document_templates/${id}/edit`);
  };

  return (
    <Row gutter={[24, 24]} style={{ padding: "16px" }}>
      <Col xs={24}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button 
            type="text" 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate(-1)()}
          >
            {t('Return back')}
          </Button>
          <Title level={2}>{t('Document Templates')}</Title>
        </Space>
        <Button
          type="primary"
          onClick={() => navigate('/document_templates/create')}
          icon={<PlusOutlined />}
          size="large"
          style={{ marginBottom: 16 }}
        >
          {t('Create Document Template')}
        </Button>
        {contextHolder}
        <ListItemsDataTable
          dtoConfig={tableDto}
          data={documentTemplates}
          filter={filter}
          onFilterChange={setFilter}
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          limit={filter.limit}
          loading={loading || loadingDelete}
          handleDeleteRow={handleDelete}
          handleEditForm={handleEdit}
          enableActionButtons={true}
        />
        {error && (
          <div style={{ color: 'red', marginTop: 16 }}>{error}</div>
        )}
      </Col>
    </Row>
  );
};

export default DocumentTemplateListScreen; 